module.exports = __webpack_public_path__ + "static/gucludonusum-dc3391a8b14f0c08efe8e70ea4419c17.png";